export const CLEAR_RESULTS_FOR_POOL_REQUEST = 'CLEAR_RESULTS_FOR_POOL_REQUEST';

export const clearResultsForPoolRequest = () => ({
    type: CLEAR_RESULTS_FOR_POOL_REQUEST,
});
